import { Box, Typography } from '@mui/material';
import Container from '../../layout/Container';
import SearchList from './SearchList';
import PropTypes from 'prop-types';
import Link from '../../components/Link';
import ScrollToTop from '../../components/ScrollToTop';

function Search({ query, items, pagination }) {
  return (
    <>
      {/* mobile top bar */}
      <Box
        display={{ xs: 'flex', md: 'none' }}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="gray.200"
        py={2}
        px={{ xs: 2, sm: 3 }}
      >
        <Link href="/" arrowDirection="left" textTransform="uppercase" color="common.black">
          <Typography variant="h4" component="p" fontWeight="bold" fontSize="0.875rem">
            Back
          </Typography>
        </Link>
      </Box>
      <Container>
        <Box display="flex" flexDirection="column" pt={{ xs: 4, md: 6 }} pb={10}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={{ xs: 4, md: 10 }}>
            <Typography variant="h1" display="flex" flexDirection="column">
              <Typography
                variant="h4"
                fontSize={{ xs: '0.875rem', sm: '1.125rem' }}
                component="span"
                mb={2}
                textTransform="uppercase"
                fontWeight="bold"
                textAlign="center"
              >
                PG&amp;E Products and Resources
              </Typography>
              {query && (
                <Typography variant="h2" component="span" mb={2} textAlign="center">
                  Search for &quot;<span style={{ fontWeight: 'bold' }}>{query}</span>&quot;
                </Typography>
              )}
            </Typography>
            <Typography
              variant="h4"
              fontSize={{ xs: '0.875rem', sm: '1.125rem' }}
              component="span"
              textAlign="center"
            >
              Everything you need to reduce costs and maximize savings
            </Typography>
          </Box>

          <Box display="flex" flexDirection="column" alignItems="center">
            <Box sx={{ maxWidth: '963px' }}>
              <SearchList items={items} pagination={pagination} />
            </Box>
          </Box>
        </Box>

        <ScrollToTop />
      </Container>
    </>
  );
}

Search.propTypes = {
  items: PropTypes.array,
  pagination: PropTypes.object,
};

export default Search;
